import reducer from './reducer';
import saga from './saga';

export default {
  saga,
  reducer
};
